import request from "@/utils/request.js";
import { GUIDE_ROLE } from "./config.js";
import _ from "lodash";

/**
 * 获取所有角色
 */
export const getAllRole = () => {
    return request.get(GUIDE_ROLE.get_all_role);
};